/*
 * File: GetAllSections.ts
 * Author: Austin Robinson
 * Date Created: 8/1/2023
 * Copyright (c) DrivingDoc 2023
 */

import { privateApi } from 'api';
import { createQuery } from 'react-query-kit';


export type GetPaymentMethodsParams = {
    type: 'all' | 'payments' | 'refunds';
    enabled?: boolean;
}

export type PaymentMethod = {
    tenant_id: string;
    id: string;
    name: string;
    enabled: boolean;
    allow_method_for_payment: boolean;
    allow_method_for_refund: boolean;
}

export type GetPaymentMethodsResult = PaymentMethod[];

async function getPaymentMethods(params: GetPaymentMethodsParams): Promise<GetPaymentMethodsResult> {
    // create new URL object for the API endpoint
    const requestUrl = new URL(`${import.meta.env.VITE_API_BASE_URL}/finance/payment-methods`);

    // create new URLSearchParams object to store query parameters
    const searchParams = new URLSearchParams();

    // add each parameter to searchParams if the value is not null or undefined
    Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            searchParams.set(key, String(value));
        }
    });

    // add the query string to the requestUrl
    requestUrl.search = searchParams.toString();

    // make api call
    const result = await privateApi.get(requestUrl.toString());

    // return the data object
    return result.data as GetPaymentMethodsResult;
}

const useGetPaymentMethods = createQuery<GetPaymentMethodsResult, GetPaymentMethodsParams, Error>({
    queryKey: ['paymentMethods'],
    fetcher: (variables) => getPaymentMethods(variables),
})

export { useGetPaymentMethods };

